import { render, staticRenderFns } from "./kgSetUp.vue?vue&type=template&id=2a84266c&scoped=true&"
import script from "./kgSetUp.vue?vue&type=script&lang=js&"
export * from "./kgSetUp.vue?vue&type=script&lang=js&"
import style0 from "./kgSetUp.vue?vue&type=style&index=0&id=2a84266c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a84266c",
  null
  
)

export default component.exports